import type { ReactNode } from 'react';
import { RecordPicker } from '../../components/RecordPicker.js';

interface DocumentOption {
  readonly documentId: string;
  readonly documentCode: string;
  readonly documentName: string;
}

interface Props {
  readonly label: string;
  readonly value: string;
  readonly onPick: (documentId: string, label: string) => void;
}

/** A document of the repository, picked by its code and name. */
export function DocumentPicker({ label, value, onPick }: Props): ReactNode {
  return (
    <RecordPicker<DocumentOption>
      endpoint="/v1/documents?limit=200"
      idField="documentId"
      label={label}
      testId="documentId"
      value={value}
      optionLabel={(d) => `${d.documentCode} \u2014 ${d.documentName}`}
      onPick={onPick}
    />
  );
}
